import {controller, target, targets} from '@github/catalyst'

@controller
export default class AffectedProductRowElement extends HTMLElement {
  @target destroyInput: HTMLInputElement
  @target ecosystemOtherInputElement: HTMLInputElement
  @target ecosystemSelectElement: HTMLSelectElement
  @target packageInputElement: HTMLInputElement
  @target unsupportedEcosystemMessageElement: HTMLElement
  @targets inputs: Array<HTMLInputElement | HTMLSelectElement>

  connectedCallback() {
    // When choosing `Other`, navigating elsewhere, then clicking the browser back
    // button, the browser remembers the value for the select, but it does not
    // change the hidden attribute and make the input type text shown.
    // The timeout is necessary because the prefilling of the value might not
    // occur until this enclosing function execution is over.
    setTimeout(() => {
      if (this.ecosystemOtherInputElement) {
        this.ecosystemOtherInputElement.hidden = this.ecosystemSelectElement.value !== 'other'
      }
    }, 0)
    setTimeout(() => {
      this.showUnsupportedEcosystemMessage()
    })
  }

  clear() {
    for (const element of this.inputs) {
      element.value = ''
    }
    this.ecosystem = this.initialEcosystem
  }

  delete() {
    this.dispatchEvent(new CustomEvent('affected-product-row-delete', {bubbles: true, detail: this}))
  }

  focusFirstInput() {
    this.ecosystemSelectElement.focus()
  }

  hide() {
    this.hidden = true
    for (const input of this.inputs) {
      // So the enclosing form doesn't become invalid due to hidden fields that are required
      input.required = false
    }
  }

  get ecosystem(): string {
    return this.ecosystemSelectElement.value
  }

  set ecosystem(ecosystemValue: string) {
    this.ecosystemSelectElement.value = ecosystemValue
    this.ecosystemOtherInputElement.hidden = ecosystemValue !== 'other'
  }

  get ecosystemOther(): string {
    return this.ecosystemOtherInputElement.value
  }

  set ecosystemOther(ecosystemValue: string) {
    this.ecosystemOtherInputElement.value = ecosystemValue
  }

  get initialEcosystem() {
    return this.getAttribute('data-initial-ecosystem') || ''
  }

  get package(): string {
    return this.packageInputElement.value
  }

  set package(packageValue: string) {
    this.packageInputElement.value = packageValue
  }

  markToDestroy() {
    this.destroyInput.value = 'true'
  }

  handleInputBlur(event: InputEvent) {
    const input = event.target as HTMLInputElement
    const erroredFormGroup = input.closest('dl.form-group.errored')
    if (erroredFormGroup) {
      erroredFormGroup.classList.remove('errored')
    }
  }

  showUnsupportedEcosystemMessage() {
    if (!this.unsupportedEcosystemMessageElement) return

    if (this.ecosystemSelectElement.value) {
      this.unsupportedEcosystemMessageElement.hidden = this.ecosystemSelectElement.value === 'pip'
      return
    }
    this.unsupportedEcosystemMessageElement.hidden = true
  }
}
